module.exports = __webpack_public_path__ + "static/media/wicketGrid.f5a0d4d2.jpg";